import { Avatar, Box, TableCell, TableRow, Tooltip, Typography } from '@mui/material'
import AccountAvatar from '~/account/account-avatar'
import { formatPublishedDate } from './journal-utils'

const ENTRY_TYPE_COLOR = {
  crop: 'success',
  crop_task: 'primary',
  org_task: 'warning',
  report: 'secondary',
}

const AVATAR_SIZE = 24

export const JournalListItem = ({ entry, selected, onClick }) => {
  const avatarUrl = entry.writtenBy?.avatar_url ?? null
  const displayName = entry.writtenBy?.username || entry.writtenBy?.email || '—'

  return (
    <TableRow
      hover
      selected={selected}
      onClick={onClick}
      sx={{ cursor: 'pointer' }}
    >
      <TableCell sx={{ maxWidth: 160, verticalAlign: 'middle' }}>
        <Typography
          variant="body2"
          noWrap
          sx={{ color: `${ENTRY_TYPE_COLOR[entry.type]}.main` }}
        >
          {entry.subject || '—'}
        </Typography>
      </TableCell>

      <TableCell sx={{ verticalAlign: 'middle' }}>
        <Tooltip title={displayName} placement="top">
          <Box sx={{ display: 'inline-block' }}>
            {avatarUrl ? (
              <Avatar
                src={avatarUrl}
                alt={displayName}
                sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE }}
              />
            ) : (
              <Avatar sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE, bgcolor: 'primary.light' }}>
                {displayName ? (
                  <Typography variant='body2' fontSize={12} color='#fff'>
                    {displayName.charAt(0).toUpperCase()}
                  </Typography> 
                ) : <Icons.AccountCircle />}
              </Avatar>
            )}
          </Box>
        </Tooltip>
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>
        <Typography variant="body2" color="text.secondary">
          {formatPublishedDate(entry.publishedAt)}
        </Typography>
      </TableCell>

      <TableCell sx={{ maxWidth: 220, verticalAlign: 'middle' }}>
        <Typography variant="body2" noWrap fontWeight={500}>
          {entry.title}
        </Typography>
      </TableCell>

      <TableCell sx={{ maxWidth: 300, verticalAlign: 'middle' }}>
        <Typography
          variant="body2"
          color="text.secondary"
          noWrap
        >
          {entry.notes}
        </Typography>
      </TableCell>
    </TableRow>
  )
}
